import { DatePicker, ThemeProvider, Tooltip } from '@alphonsocode/kallos';
import React, { useState, useMemo, useEffect } from 'react';
import { DatePickerStyle } from './style';
import { DateObject } from 'react-multi-date-picker';
import useQuery from 'reusable/customHooks/useQuery';
import Footer from 'react-multi-date-picker/plugins/range_picker_footer';
import { track } from 'analytics/posthog';

function DatePickerComponent({ mosaicRedirect }) {
  const [query, setQuery] = useQuery();
  const displayFormat = 'YYYY/MM/DD';
  const queryFormat = 'YYYY-MM-DD';

  const initialRange = useMemo(() => {
    const now = new Date();
    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(now.getDate() - 1);

    const startQuery = query.get('startDate');
    const endQuery = query.get('endDate');

    const start = startQuery
      ? new DateObject({ date: startQuery, format: queryFormat }).format(
          displayFormat,
        )
      : new DateObject(twoDaysAgo).format(displayFormat);
    const end = endQuery
      ? new DateObject({ date: endQuery, format: queryFormat }).format(
          displayFormat,
        )
      : new DateObject(now).format(displayFormat);

    return [start, end];
  }, [displayFormat, query, queryFormat]);

  useEffect(() => {
    const startQuery = query.get('startDate');
    const endQuery = query.get('endDate');

    if (!startQuery) {
      setQuery(
        'startDate',
        new DateObject({
          date: initialRange[0],
          format: displayFormat,
        }).format(queryFormat),
      );
    }

    if (!endQuery) {
      setQuery(
        'endDate',
        new DateObject({
          date: initialRange[1],
          format: displayFormat,
        }).format(queryFormat),
      );
    }
  }, [displayFormat, initialRange, query, queryFormat, setQuery]);

  const [selectedRange, setSelectedRange] = useState(initialRange);

  useEffect(() => {
    setSelectedRange(initialRange);
  }, [initialRange]);

  const handleRangeChange = selectedDates => {
    if (Array.isArray(selectedDates) && selectedDates.length === 2) {
      const [start, end] = selectedDates;
      const nextRange = [
        start.format(displayFormat),
        end.format(displayFormat),
      ];

      if (
        nextRange[0] !== selectedRange[0] ||
        nextRange[1] !== selectedRange[1]
      ) {
        setSelectedRange(nextRange);

        setQuery({
          startDate: start.format(queryFormat),
          endDate: end.format(queryFormat),
          page: '1',
        });
        track('adsure date range changed', {
          start_date: start.format('YYYY-MM-DD'),
          end_date: end.format('YYYY-MM-DD'),
          surface: 'adsure',
        });
      }
    }
  };

  return (
    <DatePickerStyle>
      <div className="date-picker">
        <label className="heading">Date Range</label>
        {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
        <ThemeProvider defaultMode="light">
          {mosaicRedirect ? (
            <Tooltip
              overlay={'Date range is disabled in Mosaic View.'}
              openDelay={0}
              closeDelay={0}
              arrow={true}
              style={{
                maxWidth: '300px',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
              side="top"
            >
              <div>
                <DatePicker
                  value={selectedRange}
                  format={displayFormat}
                  onChange={handleRangeChange}
                  range
                  rangeHover
                  allowPartialRange={false}
                  disabled
                />
              </div>
            </Tooltip>
          ) : (
            <DatePicker
              value={selectedRange}
              format={displayFormat}
              onChange={handleRangeChange}
              range
              rangeHover
              allowPartialRange={false}
            />
          )}
        </ThemeProvider>
      </div>
    </DatePickerStyle>
  );
}

export default DatePickerComponent;
